import type React from 'react';

export interface Component extends React.Component {
  _resizeEventListener?: {
    handleEvent: () => void;
  };
  resize: () => void;
}

function addListener(component: Component) {
  component._resizeEventListener = {
    handleEvent: () => {
      component.resize();
    },
  };

  window.addEventListener('resize', component._resizeEventListener);
}

function removeListener(component: Component) {
  if (!component._resizeEventListener) {
    return;
  }
  window.removeEventListener('resize', component._resizeEventListener);
  delete component._resizeEventListener;
}

export default { addListener, removeListener };
